import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import axios from "axios";
import { axiosErrorHandler } from "../../../../../swzutils";
import React, { useImperativeHandle, useState } from "react";
import { Spin } from "antd";
import ValOrDash from "../../../components/ValOrDash";
import ShortfallValueWithIcon from "../ShortfallValueWithIcon";
import HelpLabel from "../../../components/HelpLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
const VehiclesRequiredWidget = (props, exportedRef) => {
    const [stateLoading, setStateLoading] = useState(false);
    const [stateData, setStateData] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    // useEffect(() => {
    //     loadVehiclesRequired()
    // }, []);
    // useEffect(() => {
    //     if (props.date) {
    //         loadVehiclesRequired();
    //     }
    // }, [props.date]);
    const refresh = () => {
        loadVehiclesRequired();
    };
    const loadVehiclesRequired = () => {
        setStateLoading(true);
        axios.get(`/admin/v1/dashboard/vehicles-required/${props.date}`)
            .then(response => {
            setStateData(response.data);
        }).catch(error => {
            axiosErrorHandler(error);
        }).finally(() => {
            setStateLoading(false);
        });
    };
    const { vehiclesRequired, vehiclesAvailable, vehicleShortfall, totalDeliveries } = stateData ?? {};
    return (_jsx(Spin, { spinning: stateLoading, children: _jsxs("div", { className: "widget", children: [_jsx("div", { className: "widget-icon widget-icon-dk-blue", children: _jsx(FontAwesomeIcon, { icon: faTruck }) }), _jsx("h2", { className: "widget-value", children: _jsx(ValOrDash, { val: vehiclesRequired }) }), _jsxs("p", { children: ["Vehicles Required for ", _jsx("strong", { children: _jsx(ValOrDash, { val: totalDeliveries }) }), " deliveries", _jsx(HelpLabel, { title: "", size: "large", helpText: _jsxs("div", { children: [_jsx("p", { children: "An estimate of the number of vehicles required for the specified deliveries.  This calculation uses the [Default Delivery Efficiency Rate] setting.  The formula is as follows" }), _jsx("p", { children: "[Vehicles Required] = [Number of deliveries] x [Default Delivery Efficiency Rate] / [Max hours for each vehicle]" })] }) })] }), _jsx("div", { className: "widget-separator" }), _jsx("h2", { className: "widget-value", children: _jsx(ShortfallValueWithIcon, { shortfallValue: vehicleShortfall }) }), _jsxs("p", { children: ["Vehicle Shortfall (", _jsx("strong", { children: _jsx(ValOrDash, { val: vehiclesAvailable }) }), " available)", _jsx(HelpLabel, { title: "", helpText: _jsx("div", { children: _jsx("p", { children: "The shortfall of vehicles.  This value is determined by subtracting the vehicles available from the vehicles required." }) }) })] })] }) }));
};
export default React.forwardRef(VehiclesRequiredWidget);
